import { loadProperty } from './load-property/index.tsx';
import {
	saveProperty,
	savePropertyWithoutSendRequest,
	sendUpdatePropertyRequest,
} from './save-property/index.tsx';

const actions = {
	loadProperty,
	saveProperty,
	savePropertyWithoutSendRequest,
	sendUpdatePropertyRequest,
};

export default actions;
